import React, { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import { unitActions } from "../../../redux/actions/guides";
import { SimpleModal, MyInput, DialogModal } from "../../../components";
import * as Yup from "yup";
import DeleteIcon from '@material-ui/icons/Delete';
import { Button } from "@material-ui/core";
import { useStateIfMounted } from "use-state-if-mounted";

const defaultValues = { fullNameUnit: "", nameUnit: "", digitalUnit: "" };

const validationSchema = Yup.object().shape({
  nameUnit: Yup.string().max(60, "Превышено максимальное кол-во символов(60)").required("Обязательное для заполнения поле"),
  fullNameUnit: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").required("Обязательное для заполнения поле"),
  digitalUnit: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
});

export const ModalUnit = ({ modalShow, onClose, id, refresh = () => { } }) => {
  const dispatch = useDispatch();
  const { item, loadingItem, fetchedItem, deleted, error } = useSelector((state) => state.guides.units);

  const [deleteDialog, setDeleteDialog] = useStateIfMounted(false);
  const [isAddMode, setIsAddMode] = useStateIfMounted(true);

  // Основной эффект для определения режима
  useEffect(() => {
    if (!modalShow) return;
    
    const addMode = id == null || isNaN(id);
    setIsAddMode(addMode);
    
    // Если это режим добавления, сбрасываем форму
    if (addMode) {
      reset(defaultValues);
      clearErrors();
    }
  }, [modalShow, id]);

  const {
    control,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  const onSubmit = (data) => {
    return isAddMode ? dispatch(unitActions.create(data)) : dispatch(unitActions.update(item.id, data));
  };

  // Эффект для загрузки данных при редактировании
  useEffect(() => {
    if (!modalShow || isAddMode || !id) return;

    dispatch(unitActions.getById(id));

    return () => dispatch({ type: "RESET_ITEM_UNITS" });
  }, [modalShow, id, isAddMode]);

  // Эффект для заполнения формы при получении данных
  useEffect(() => {
    if (!fetchedItem || isAddMode || !modalShow) return;

    Object.keys(defaultValues).forEach((field) => setValue(field, item[field]));
  }, [item, fetchedItem, isAddMode, modalShow]);

  const handleDeleteClick = useCallback((id) => {
    dispatch(unitActions.delete(id));
    setDeleteDialog(false);
  }, [dispatch, setDeleteDialog]);

  // Эффект для обработки успешного удаления
  useEffect(() => {
    if (deleted && modalShow) {
      setDeleteDialog(false);
      closeModalFunc();
      onClose();
      refresh();
      console.log('Единица измерения успешно удалена');
    }
  }, [deleted]);

  const closeModalFunc = () => {
    clearErrors();
    reset(defaultValues);
  };

  return (
    <div>
      <SimpleModal
        modalTitle={isAddMode ? "Новая единица измерения" : "Редактирование"}
        winPermissionName="Общие"
        modalShow={modalShow}
        modalSize="sm"
        fullScreen={false}
        loading={loadingItem}
        isAddMode={isAddMode}
        status={!isAddMode}
        operations={item}
        onSubmit={handleSubmit(onSubmit)}
        onClose={() => {
          onClose();
          closeModalFunc();
        }}
      >
        <form noValidate>
          <MyInput name="nameUnit" control={control} label="Краткое наименование" required errors={errors?.nameUnit} />
          <MyInput name="fullNameUnit" control={control} label="Полное наименование" required errors={errors?.fullNameUnit} />
          <MyInput name="digitalUnit" control={control} label="Цифровой код" />
          <div>
            <Button
              disabled={isAddMode}
              aria-describedby={id}
              size="small"
              color="primary"
              onClick={() => setDeleteDialog(true)}
              startIcon={<DeleteIcon />}
            >
              Удалить
            </Button>
          </div>
        </form>
      </SimpleModal>
      <DialogModal
        open={deleteDialog}
        onConfirmDialogClose={() => setDeleteDialog(false)}
        onYesClick={() => handleDeleteClick(item?.id)}
        text={`Вы действительно хотите удалить единицу измерения - ${item?.nameUnit}? Это действие невозможно отменить.`}
      />
    </div>
  );
};